/**
 * True / False — вариант задания `true_false_ng` без «Not Given» (решение владельца 13.10.2026).
 *
 * ⚠️ ВАРИАНТ, А НЕ НОВЫЙ ТИП. `content.not_given: false` — и всё: рендерер, проверка,
 * нумерация и сторож «нет верного ответа» уже есть. Нет поля — «Not Given» есть, старые
 * задания не меняются. Приложение 1.1.1 поля не знает и покажет лишнюю кнопку «Not Given»
 * — её выбор просто неверен; новый тип оно показало бы сырым JSON с ответами
 * (договор docs/CONTRACTS/block-types-1.1.2.md).
 */
export const tfNotGivenAllowed = (content: unknown): boolean =>
  (content as { not_given?: unknown } | null | undefined)?.not_given !== false;
